import { TranslationActionType } from '../action-types'

export const changeLanguage = (lang: string) => ({
    type: TranslationActionType.SWITCH_LANGUAGE,
    payload: lang,
})
